import { render } from "./index.vue?vue&type=template&id=15b5cf82&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=15b5cf82&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=15b5cf82&lang=scss"

import exportComponent from "/devops/jenkins_new/jenkins02-node1/workspace/Record_web_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15b5cf82"]])

export default __exports__